import React from "react";

/**
 * Lightweight CSS-only tooltip for icon-only buttons.
 * Usage: <Tooltip label="Refresh">{<button/>}</Tooltip>
 */
export default function Tooltip({ label, children, side = "top", className = "" }) {
    const sides = {
        top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
        bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
        right: "left-full top-1/2 -translate-y-1/2 ml-2",
    };
    return (
        <span className={`group/tt relative inline-flex ${className}`}>
            {children}
            <span
                role="tooltip"
                className={`pointer-events-none absolute z-[60] whitespace-nowrap rounded-lg bg-slate-900 px-2.5 py-1.5 text-xs font-medium text-white opacity-0 shadow-pop transition-opacity duration-150
                    group-hover/tt:opacity-100 dark:bg-slate-700 ${sides[side] || sides.top}`}
            >
                {label}
            </span>
        </span>
    );
}
